import { useSupportSheet } from "../../components/SupportSheet";
import { memo } from "react";
import { useStore } from "../../store/globalState";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  AuraLayout,
  Button,
  CashSpecialIcon,
  GradientText,
  Layout,
  SupportIcon,
  Title,
} from "lola-framework-ui-test";
import { FlowHeroMark } from "../../components/FlowHeroMark";
import { ConsumerSessionMenu } from "../../components/consumer-auth/ConsumerSessionMenu";
import { PAYOUT_CLAIM_ROUTES, TITLE_COLOR } from "../../constants";
import { formatLabeledAmount } from "../../utils";
import { ScrollFadeIndicator } from "../../components/ScrollFadeIndicator";
import { Navbar } from "../../components/Navbar";

const SENDER_NAME = "Carlos Mendoza";
const RECEIVE_AMOUNT = 1850;
const DESTINATION_CURRENCY = "MXN";

export const PayoutClaimEntryPage = memo(() => {
  const { t } = useTranslation("payout-claim");
  const { theme } = useStore();
  const colorConfig = theme.whiteView;
  const {
    background,
    backgroundBtn,
    textColorBtn,
    dropzoneColors,
    backgroundIcon,
  } = colorConfig;
  const navigate = useNavigate();
  const { openSupport, supportSheet } = useSupportSheet("payout-claim");

  const formattedAmount = formatLabeledAmount(
    RECEIVE_AMOUNT,
    DESTINATION_CURRENCY
  );

  return (
    <>
    <AuraLayout colorConfig={colorConfig} className="scrollable need-help-header">
      <Layout.Header>
        <ConsumerSessionMenu />
        <Navbar
          title={t("common.needHelp")}
          align="right"
          noBackButton
          onIconClick={openSupport}
          icon={<SupportIcon size={35} colors={dropzoneColors} />}
        />
      </Layout.Header>
      <Layout.Content className="landing-section fund-request-section">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <Title
          title={t("payoutClaim.sentYou", { name: SENDER_NAME })}
          align="left"
          color={TITLE_COLOR}
        />
        <section className="fund-request-hero">
          <div className="fund-request-disc">
            <FlowHeroMark
              dropzoneColors={dropzoneColors}
              backgroundIcon={backgroundIcon}
            >
              <CashSpecialIcon size={60} colors={dropzoneColors} />
            </FlowHeroMark>
          </div>

          <section className="landing-container fund-request-amount">
            <GradientText
              as="label"
              textColor={TITLE_COLOR}
              className="fund-request-label"
            >
              {t("payoutClaim.theySentYou")}
            </GradientText>
            <GradientText as="h1" textColor={TITLE_COLOR}>
              {formattedAmount}
            </GradientText>
          </section>
        </section>
      </Layout.Content>

      <Layout.Footer>
        <section className="footer-section">
          <Button
            type="button"
            variant="cancel"
            size="small"
            color={TITLE_COLOR}
            className="fund-request-discard"
            onClick={() => navigate(PAYOUT_CLAIM_ROUTES.DISCARD)}
          >
            {t("payoutClaim.discard")}
          </Button>
          <section className="fund-request-actions fund-request-actions--stack">
            <Button
              type="button"
              size="large"
              variant="outline"
              background={backgroundBtn}
              color={TITLE_COLOR}
              style={{ backgroundColor: background }}
              onClick={() => navigate(PAYOUT_CLAIM_ROUTES.LATER)}
            >
              {t("payoutClaim.later")}
            </Button>
            <Button
              type="button"
              size="large"
              background={backgroundBtn}
              color={textColorBtn}
              onClick={() => navigate(PAYOUT_CLAIM_ROUTES.TRANSFER)}
            >
              {t("payoutClaim.claim")}
            </Button>
          </section>
        </section>
      </Layout.Footer>
    </AuraLayout>
    {supportSheet}
  </>
  );
});
